import { NgModule } from "@angular/core";

import { NumericNotZeroValidatorDirective } from "./numeric-not-zero-validator.directive";

const DIRECTIVES = [NumericNotZeroValidatorDirective];

@NgModule({
	imports: [],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class NumericNotZeroValidatorModule {}
